declare var $: any;
import {
  Component,
  OnInit,
  TemplateRef,
  AfterViewInit,
  ViewChild
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from '../../base/base-component.component';
import {
  PageModel,
  PageFacade,
  UiNotificationService,
  LanguageModel,
  FilterPagination,
  FormValidationsService,
  Schema,
  DynamicSchemaFactory
} from '../../services';
import { PageInternalService } from '../../services/squidex/services/page-internal.service';
import {
  Field,
  DataParser
} from '../../services/squidex';
import { combineLatest, Observable } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { AppToken, DefaultContents, FieldsName, Statuses, AppSchemaCategory } from '../../models/app-token';
import {
  SiteSettingFacade,
  LayoutModel,
  TemplateModel,
  LayoutFacade,
  TemplateFacade,
  PageContentFacade,
  MenuFacade,
  MenuItemFacade,
  DynamicContentSchemaFactory
} from '../../services/akita/index';
import { PageTitleService } from '../../services/general/page-title.service';
import { Validation } from '../../tools';
import { ESchemaContentStatus } from '../../services/akita/base/enum';
import { PageTypeFacade } from "../../services/akita/page-type/page-type.facade";
import { SpinnerService } from '../../shared/spinner/spinner.service';
import { Router } from '@angular/router';
import { ContentInternalService } from '../../services/squidex/services/content-internal.service';
const EMPTY = '';

@Component({
  selector: 'pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.css'],
})
export class PagesComponent extends BaseComponent implements OnInit, AfterViewInit {

  public paginationSize = 10;
  public publishCount: number;
  public currentPage = 1;


  public paginationSizeContents = 10;
  public publishCountContents: number;
  public currentPageContents = 1;


  private filter: FilterPagination;


  selectedLanguage: string;
  selectedSort: string;
  selectedSortIndex: string;

  pages: PageModel[];
  contentsAsPage: PageModel[];
  schemas: Schema[];
  publishedPages: PageModel[];
  unpublishedPages: PageModel[];

  private availableLanguages: LanguageModel[];

  listView = false;
  hiddenFields: string[] = [];

  formGroup: FormGroup;
  fields: Field[] = [];
  creationFields: Field[] = [];
  searchControl: FormControl;

  modalRef: BsModalRef;
  datePicker: BsDatepickerModule;
  bsConfig: Partial<BsDatepickerConfig>;

  private pageSelected: PageModel;
  private pageLayouts: LayoutModel[];
  private pageTemplates: TemplateModel[];

  private placeholderPageType: any;

  isCollapsed = true;

  collapseControlsEditTemplate: any = {};

  private readonly dataParser: DataParser;
  languageCustomClass = 'language-nav-tabs';

  cloneNgModel: any = {};
  cloneSubmited: boolean = false;
  selectedPageIsContent: boolean = false;

  @ViewChild('cloneTemplate', { static: true })
  cloneTemplate: TemplateRef<any>;

  @ViewChild('deleteTemplate', { static: true })
  deleteTemplate: TemplateRef<any>;

  @ViewChild('formTemplate', { static: true })
  formTemplate: TemplateRef<any>;

  maxSize: number = 33;

  constructor(translateService: TranslateService,
    private readonly pageTitleService: PageTitleService,
    private readonly pageFacade: PageFacade,
    private readonly layoutFacade: LayoutFacade,
    private readonly templateFacade: TemplateFacade,
    private readonly pageContentFacade: PageContentFacade,
    private readonly menuFacade: MenuFacade,
    private readonly menuItemFacade: MenuItemFacade,
    private readonly contentFacadeFactory: DynamicContentSchemaFactory,
    private readonly schemaFacadeFactory: DynamicSchemaFactory,
    private readonly modalService: BsModalService,
    private readonly uiNotificationService: UiNotificationService,
    private readonly siteSettingFacade: SiteSettingFacade,
    private readonly pageTypeFacade: PageTypeFacade,
    private readonly formValidationService: FormValidationsService,
    private readonly spinnerService: SpinnerService,
    readonly router: Router,
    private readonly pageInternalService: PageInternalService,
    private readonly contentInternalService: ContentInternalService
  ) {
    super(translateService);
    this.setTranslateContext('PagesComponent');
    this.hiddenFields = ['deleted', 'publishdatetime',
      'deletedatetime', 'metatitle',
      'metaDescription', 'metaKeywords',
      'pageType', 'thumbnail'];
    this.dataParser = new DataParser(null);
    this.searchControl = new FormControl();
  }

  ngOnInit(): void {

    this.spinnerService.hide();
    const subscription = this.tc().subscribe(v => {
      this.pageTitleService.setTitle(v['TITLE']);
      this.pageTitleService.key = 'PAGES.TITLE';
    });

    this.subscriptions.push(subscription);
    this.filter = new FilterPagination(0, this.paginationSize, 'lastModified descending');
    this.language = this.pageFacade.getCurrentLanguage();
    this.bsConfig = Object.assign({}, { containerClass: 'theme-orange', dateInputFormat: 'YYYY/MM/DD HH:mm' });

    this.initializeData();
    this.initializeSearch();
    this.selectedSort = 'Date de modification';
    this.selectedSortIndex = '0';

    this.maxSize =   Math.floor( window.innerWidth * .017) + 1
  }

  ngAfterViewInit() {
  }


  createForm(schemaFields: Field[], page: PageModel = null): void {
    const formGroup = this.generateFormGroup(this.pageFacade, schemaFields, this.hiddenFields, page, false, this.formValidationService);

    let statusControl: any;

    if (page) {
      statusControl = new FormControl(page.status === this.statusPublished);
    }
    else {
      statusControl = new FormControl(false);
    }

    formGroup["status"] = statusControl;

    this.formGroup = new FormGroup(formGroup);
    //add requered to url in all lang
    for (const language of this.availableLanguages.map(languages => languages.data.code.iv)) {
      this.formGroup.get('url_' + language).setValidators(Validators.required);
    }
  }

  submitForm() {
    if (!this.formGroup.valid || !this.formGroup.dirty) {
      this.formGroup.markAllAsTouched();
      return;
    }

    const values = this.formGroup.value;

    let newPageData: any = {};

    for (let field of this.creationFields) {
      if (field.partitioning === 'language') {
        for (const language of this.availableLanguages.map(languages => languages.data.code.iv)) {
          newPageData = this.dataParser.setData(newPageData, field, values[field.name + '_' + language], language);
        }
      } else {
        newPageData = this.dataParser.setData(newPageData, field, values[field.name]);
      }
    }

    const urls = new Array();
    for (const language of this.availableLanguages.map(languages => languages.data.code.iv)) {
      urls.push(newPageData['url'][language]);
    }

    const urlsDistinct = [...new Set(urls)];
    if (urls > urlsDistinct) {
      this.pageFacade.translate('T').subscribe(c => {
        this.uiNotificationService.error(c.URL_NOT_DISTINCT, c.FAILED_TITLE, 10000);
      });
      return;
    }
    let startWithSlash: boolean = true;
    urls.forEach(url => {
      if (!url.trim().startsWith('/')) {
        startWithSlash = false;
        return;
      }
    })

    if (!startWithSlash) {
      this.pageFacade.translate('T').subscribe(c => {
        this.uiNotificationService.error(c.URL_START_SLASH, c.FAILED_TITLE, 10000);
      });
      return false;
    }

    const allVersionParm = new FilterPagination();
    allVersionParm.from = 0;
    allVersionParm.to = 1;
    allVersionParm.filter = '';
    allVersionParm.orderBy = 'lastModified descending';

    let filterList: object[] = new Array();
    for (const lg of this.availableLanguages.map(languages => languages.data.code.iv)) {

      for (const language of this.availableLanguages.map(languages => languages.data.code.iv)) {
        let data: any = {};
        data = {
          path: `data.url.${lg}`,
          op: 'eq',
          value: newPageData['url'][language]
        };

        filterList.push(data);
      }
    }
    let orFilter: any = {};
    orFilter = {
      or: filterList
    }

    this.pageFacade.validateUrl(allVersionParm, ESchemaContentStatus.All, orFilter, this.pageSelected).subscribe(total => {
      if (total > 0) {
        this.pageFacade.translate('T').subscribe(c => {
          this.uiNotificationService.error(c.URL_TAKEN, c.FAILED_TITLE, 10000);
        });
        return;
      }

      if (this.pageSelected) {
        this.pageFacade
          .update(this.pageSelected.id, newPageData)
          .subscribe(v => {
            if (v) {
              const index = this.pages.indexOf(this.pageSelected);
              if (index !== -1) {
                this.pages[index] = v;
              }
              this.setStatus(this.pageSelected.id, values.status)
              this.pageFacade.translate('T').subscribe(c => {
                this.uiNotificationService.success(c.UPDATE_SUCCESS, c.SUCCESS_TITLE);
                this.closeModal();
              });
            }
          });
      } else {
        const pageTypeFacade = this.contentFacadeFactory.getDynamicContentSchemaFacade(AppToken.PAGE_TYPE_SCHEMA_NAME);
        let isExcutedPType = false;
        pageTypeFacade.getByCode(DefaultContents.DEFAULT_PAGE_TYPE_CODE).subscribe(pType => {
          if (!isExcutedPType) {
            newPageData = this.dataParser.setData(newPageData, this.fields.find(field => field.name === FieldsName.PAGE_TYPE), pType.id);
            this.pageFacade.create(newPageData).subscribe(v => {
              let newPage = this.clone(v);
              let newMenuItemData: any = {};
              let ids: string[] = [];
              ids.push(newPage.id);
              this.dataParser.putData(newMenuItemData, FieldsName.CODE, this.dataParser.pullData(newPage, FieldsName.CODE));
              this.dataParser.putData(newMenuItemData, FieldsName.PAGE, newPage.id);
              this.dataParser.putData(newMenuItemData, FieldsName.INDEX, 0);
              let isExcuted = false;
              this.menuItemFacade.createAsPublished(newMenuItemData).subscribe(menuItem => {
                this.menuFacade.getByCode(DefaultContents.DEFAULT_MENU_CODE).subscribe(menu => {
                  if (!isExcuted) {
                    let menuData = this.clone(menu.data);
                    let menuItems = menuData.menuItems.iv as string[];
                    menuItems.push(menuItem.id);
                    this.dataParser.putData(menuData, FieldsName.MENU_ITEMS, menuItems);
                    this.menuFacade.update(menu.id, menuData).subscribe();
                    isExcuted = true;
                  }
                });
              });

              const index = this.pages.indexOf(newPage);
              if (index === -1) {
                this.pages.push(newPage);
              }
              this.pageFacade.translate('T').subscribe(c => {
                this.uiNotificationService.success(c.UPDATE_SUCCESS, c.SUCCESS_TITLE);
                this.closeModal();
                const stat = values.status ? Statuses.PUBLISHED.name : Statuses.DRAFT.name;
                if (newPage.status !== stat) {
                  this.setStatusNew(newPage.id, values.status);
                }
              });

              let templateData: any = {};
              this.dataParser.putData(templateData, FieldsName.CODE, this.dataParser.pullData(newPage, FieldsName.CODE) + '-template');
              this.dataParser.putData(templateData, FieldsName.BODY, 'page template');
              this.dataParser.putData(templateData, 'category', 'page');

              this.templateFacade.createAsPublished(templateData).subscribe(newTemplate => {
                ids = [];
                ids.push(newTemplate.id);
                this.dataParser.putData(newPage.data, FieldsName.TEMPLATE, ids);
                this.pageFacade.update(newPage.id, newPage.data).subscribe();
              });

              this.initializeData();
            });
            isExcutedPType = true;
          }
        });
      }
    });
  }

  setStatus(id: string, status: boolean) {
    let newStatus = (status ? Statuses.PUBLISHED.name : Statuses.DRAFT.name);
    if (!this.pageSelected || this.pageSelected.status !== newStatus) {
      this.pageFacade.updateStatus(id, newStatus, null).subscribe(v => {
        const index = this.pages.indexOf(this.pageSelected);
        if (index !== -1) {
          this.pages[index] = v;
        }
        this.pageSelected = null;
      });
      this.initializeData();
    }
  }

  setStatusNew(id: string, status: boolean) {
    let newStatus = (status ? Statuses.PUBLISHED.name : Statuses.DRAFT.name)
    this.pageFacade.updateStatus(id, newStatus, null).subscribe(newPage => {
      const index = this.pages.indexOf(newPage);
      if (index === -1) {
        this.pages.push(newPage);
      }
      this.pageSelected = null;
    });
  }

  openModal(page: PageModel = null, isCreation: boolean = false,) {

    if (isCreation) {
      this.creationFields = this.fields.filter(field => !this.hiddenFields.includes(field.name));
      this.collapseAllEditForm();
      this.pageSelected = null;
      this.creationFields = this.creationFields.filter(field => field.name !== FieldsName.TEMPLATE);
      this.isCollapsed = !this.isCollapsed;
      this.createForm(this.creationFields, page);
    } else {
      let url = `/page/${this.dataParser.pullData(page, FieldsName.CODE)}`;
      this.router.navigateByUrl(url);
    }
  }

  private collapseAllEditForm() {
    const desc = this.collapseControlsEditTemplate;
    Object.keys(desc).forEach(key => {
      if (desc)
        desc[key]['isCollapsed'] = true;
    });
    this.collapseControlsEditTemplate = desc;
    this.isCollapsed = true;
    let container = document.querySelectorAll('.last_modify-inner');
    container.forEach(item => {
      item.classList.remove('bubble-content-context');
    });
  }

  closeModal() {
    this.collapseAllEditForm();
    if (this.modalRef) {
      this.modalRef.hide();
    }
  }

  openCloneModal(event: { pageModel: PageModel, isContent: boolean }) {
    this.pageSelected = event.pageModel;

    this.selectedPageIsContent = event.isContent;

    this.modalRef = this.modalService.show(this.cloneTemplate);
  }

  openDeleteModal(page: PageModel) {
    this.pageSelected = page;
    this.modalRef = this.modalService.show(this.deleteTemplate);
  }

  confirmClone() {
    let name = this.cloneNgModel['name'];

    if (Validation.isNullEmptyOrWhiteSpaces(name)) {
      this.uiNotificationService.error('Name is required', 'Error');
      return;
    }

    let urls = {};

    this.availableLanguages.forEach(lang => {
      let langCode = lang.data.code.iv;
      let url = this.cloneNgModel[`url_${langCode}`];

      if (Validation.isNullEmptyOrWhiteSpaces(url)) {
        this.uiNotificationService.error(`Url ${langCode} is required`, 'Error');
        return;
      }

      urls[langCode] = url;
    });

    //TODO: validate urls are unique and begin with /
    this.pageInternalService.clonePage(this.pageSelected.id, name, urls, this.selectedPageIsContent).subscribe(callback => {
      this.modalRef.hide();
      this.pageSelected = null;
      if (callback.isSuccess()) {
        this.initializeData();
        return;
      }

      this.uiNotificationService.error(callback.getMessage(), 'Error');
    });
  }

  confirmDelete() {

    if (Validation.isValidGuid(this.pageSelected.id)) {

      //remove all section relation from page
      this.pageContentFacade.getPageContentsByPageId(this.pageSelected.id).subscribe(pageContents => {
        if (pageContents.length > 0) {
          pageContents.forEach(pageContent => {
            this.pageContentFacade.remove(pageContent.id).subscribe();
          })
        }
      });

      //remove all content relation from page
      const schemaPageFacade = this.contentFacadeFactory.getDynamicContentSchemaFacade(AppToken.SCHEMA_PAGE_SCHEMA_NAME);
      schemaPageFacade.getByParentId(this.pageSelected.id, FieldsName.PAGE_ID, FieldsName.ID, true).subscribe(
        schemaPages => {
          if (schemaPages.length > 0) {
            schemaPages.forEach(sPage => {
              schemaPageFacade.remove(sPage.id).subscribe();
            });
          }
        });

      //remove all page filter
      const pageFilterFacade = this.contentFacadeFactory.getDynamicContentSchemaFacade(AppToken.PAGE_FILTER_SCHEMA_NAME);
      schemaPageFacade.getByParentId(this.pageSelected.id, FieldsName.PAGE_ID, FieldsName.ID, true).subscribe(
        pageFilter => {
          if (pageFilter.length > 0) {
            pageFilter.forEach(pFilter => {
              pageFilterFacade.remove(pFilter.id).subscribe();
            });
          }
        });

      const templateId = this.dataParser.pullData(this.pageSelected, FieldsName.TEMPLATE)[0];
      if (templateId) {
        //remove template related to page
        this.templateFacade.remove(templateId).subscribe();
      }

      //remove menuItem from menu then remove it
      this.menuItemFacade.getMenuItemsByPageId(this.pageSelected.id).subscribe(menuItems => {
        if (menuItems.length > 0) {
          menuItems.forEach(menuItem => {
            let isExcuted = false;
            this.menuFacade.getByParentId(menuItem.id, FieldsName.MENU_ITEMS, FieldsName.ID, true).subscribe(menus => {
              if (!isExcuted) {
                menus.forEach(menu => {
                  let menuData = this.clone(menu.data);
                  let menuItems = menuData.menuItems.iv as string[];
                  const index = menuItems.indexOf(menuItem.id);
                  if (index !== -1) {
                    menuItems.splice(index, 1);
                  }
                  this.dataParser.putData(menuData, FieldsName.MENU_ITEMS, menuItems);
                  this.menuFacade.update(menu.id, menuData).subscribe();
                  isExcuted = true;
                });
              }
            });
            this.menuItemFacade.remove(menuItem.id).subscribe();
          });
        }
      });

      //remove this page from pages array
      let draftmode = false;
      if (this.pageSelected.status === 'Draft') {
        draftmode = true;
      }

      if (this.pageSelected.schemaName === 'page') {
        this.pageFacade.remove(this.pageSelected.id, draftmode).subscribe(v => {
          const index = this.pages.indexOf(this.pageSelected);
          if (index !== -1) {
            this.pages.splice(index, 1);
          }
          this.pageSelected = null;
          this.pageFacade.translate('T').subscribe(c => {
            this.uiNotificationService.success(c.DELETE_SUCCESS, c.SUCCESS_TITLE);
          });
          this.modalRef.hide();
        });
      } else {
        const currentFacade = this.contentFacadeFactory.getDynamicContentSchemaFacade(this.pageSelected.schemaName);
        currentFacade.remove(this.pageSelected.id, draftmode).subscribe(v => {
          const index = this.contentsAsPage.indexOf(this.pageSelected);
          if (index !== -1) {
            this.contentsAsPage.splice(index, 1);
          }
          this.pageSelected = null;
          this.pageFacade.translate('T').subscribe(c => {
            this.uiNotificationService.success(c.DELETE_SUCCESS, c.SUCCESS_TITLE);
          });
          this.modalRef.hide();
        });


      }



    }
  }

  getPublished(): Array<PageModel> {
    return this.pages.filter(v => this.isPublishedContent(v)).slice(0, this.paginationSize);
  }

  getUnpublished(): Array<PageModel> {
    let unPublishedContentsAndPages: Array<PageModel> = new Array<PageModel>();
    unPublishedContentsAndPages = unPublishedContentsAndPages.concat(this.contentsAsPage.filter(v => !this.isPublishedContent(v)).slice(0, AppToken.PAGES_UNPUBLISHED_ITEMS_PER_PAGE));
    unPublishedContentsAndPages = unPublishedContentsAndPages.concat(this.pages.filter(v => !this.isPublishedContent(v)).slice(0, AppToken.PAGES_UNPUBLISHED_CONTENTS_ITEMS_PER_PAGE));
    return unPublishedContentsAndPages;
  }

  getPublishedContents(): Array<PageModel> {
    let end = (this.currentPageContents) * this.paginationSizeContents;
    if (end >= this.publishCountContents) {
      end = this.publishCountContents;
    }

    return this.contentsAsPage.filter(v => this.isPublishedContent(v)).slice((this.currentPageContents - 1) * this.paginationSizeContents, end);
  }

  getUnpublishedContents(): Array<PageModel> {
    return this.contentsAsPage.filter(v => !this.isPublishedContent(v)).slice(0, AppToken.PAGES_UNPUBLISHED_CONTENTS_ITEMS_PER_PAGE);
  }

  initializeData(): void {
    this.pages = [];
    this.contentsAsPage = [];

    this.schemaFacadeFactory.getSchemasMetadataByCategory(AppSchemaCategory.SCHEMA_AS_A_PAGE).subscribe(schemas => {
      this.schemas = schemas;
      this.schemas.forEach(sc => {
        this.contentFacadeFactory.getDynamicContentSchemaFacade(sc.name).getAll().subscribe(cts => {
          cts.forEach(ct => {
            let p = new PageModel(ct);
            let temp = this.clone(p);
            temp.data = this.dataParser.putData(temp.data, 'code', sc.name + '/' + this.dataParser.pullData(ct, 'code'), 'iv');
            this.contentsAsPage.push(temp);
          });
          this.publishCountContents = this.contentsAsPage.length;
        });
      });
    });
    this.getPages();
  }


  getPages() {
    this.unpublishedPages = [];
    this.publishedPages = [];

    if (this.listView) {
      this.paginationSize = AppToken.PAGES_PUBLISHED_ITEMS_PER_PAGE_LIST;
      this.paginationSizeContents = AppToken.PAGES_PUBLISHED_CONTENTS_ITEMS_PER_PAGE_LIST;
    } else {
      this.paginationSize = AppToken.PAGES_PUBLISHED_ITEMS_PER_PAGE;
      this.paginationSizeContents = AppToken.PAGES_PUBLISHED_CONTENTS_ITEMS_PER_PAGE;
    }

    const draftParm = new FilterPagination();
    draftParm.from = 0;
    draftParm.to = AppToken.PAGES_UNPUBLISHED_ITEMS_PER_PAGE;
    draftParm.filter = this.searchControl.value == null ? EMPTY : this.searchControl.value;
    draftParm.orderBy = 'lastModified descending';

    this.filter.from = (this.currentPage - 1) * this.paginationSize;
    this.filter.to = this.filter.from + this.paginationSize;
    this.filter.orderBy = this.getOrderBy();
    let advancedFilter = this.getSearchObject();

    const countParm = new FilterPagination();
    countParm.from = 0;
    countParm.to = 1000;
    countParm.orderBy = 'lastModified descending';
    let finalFilter = [];

    finalFilter.push(advancedFilter);

    const sub1 = this.pageTypeFacade.getPlaceholderPageType().subscribe(pageType => {
      this.placeholderPageType = pageType;

      if (this.placeholderPageType) {
        let oFilterPlaceHolder = {
          path: "data.pageType.iv",
          op: 'ne',
          value: this.placeholderPageType.id
        }
        finalFilter.push(oFilterPlaceHolder);
      }
      const subscription = combineLatest(
        this.pageFacade.getFilteredPagination(draftParm, ESchemaContentStatus.Draft, finalFilter),
        this.pageFacade.getFilteredPagination(this.filter, ESchemaContentStatus.Published, finalFilter),
        this.pageFacade.getSchema(),
        this.siteSettingFacade.getSiteLanguages(),
        this.layoutFacade.getAllOrdered(),
        this.templateFacade.getAllOrdered(),
        this.pageFacade.getFilteredPagination(countParm, ESchemaContentStatus.Published, finalFilter)
      ).subscribe(([unpublished, published, schema, languages, layouts, templates, pageCount]) => {
        this.pageLayouts = layouts;
        this.pageTemplates = templates;

        published.forEach(page => {
          this.pages.push(page);
          this.publishedPages.push(page);
        });

        unpublished.forEach(page => {
          this.pages.push(page);
          this.unpublishedPages.push(page);
        });

        if (languages.length <= 1) {
          this.languageCustomClass = 'hide-nav-tabs';
        }

        this.availableLanguages = languages;

        //init collapseControls EditTemplate
        this.pages.forEach(page => {
          const data: any = {
            isCollapsed: true,
          };
          this.collapseControlsEditTemplate[page.id] = data;
        });

        this.publishCount = pageCount.length;
        this.fields = schema.fields;
      });
      this.subscriptions.push(subscription);
    });

    this.subscriptions.push(sub1);

  }


  initializeSearch(): void {
    const subscription = this.searchControl
      .valueChanges
      .pipe(debounceTime(AppToken.INPUT_DELAY_TIMESPAN))
      .pipe(distinctUntilChanged())
      .subscribe(result => {
        if (result) {
          this.search(result);
        } else {
          this.initializeData();
        }
      });
    this.subscriptions.push(subscription);
  }

  search(filter?: string, lightRefresh: boolean = false): void {
    if (lightRefresh) {
      const drafts = this.pages.filter(a => a.status === 'Draft');
      this.pages = [];
      this.publishedPages = [];
      this.pages = drafts;
    } else {
      this.pages = [];
      this.unpublishedPages = [];
      this.publishedPages = [];
    }

    if (!filter) {
      filter = this.searchControl.value === null ? '' : this.searchControl.value;
    }

    const countParm = new FilterPagination();
    countParm.from = 0;
    countParm.to = 1000;
    countParm.orderBy = 'lastModified descending';

    const draftParm = new FilterPagination();
    draftParm.from = 0;
    draftParm.to = AppToken.PAGES_UNPUBLISHED_ITEMS_PER_PAGE;
    draftParm.orderBy = 'lastModified descending';

    this.filter.from = (this.currentPage - 1) * this.paginationSize;
    this.filter.to = this.filter.from + this.paginationSize;
    this.filter.orderBy = this.getOrderBy();
    const advancedSearch = this.getSearchObject();

    let finalFilter = [];

    finalFilter.push(advancedSearch);

    const subscription = this.pageTypeFacade.getPlaceholderPageType().subscribe(pageType => {
      this.placeholderPageType = pageType;

      if (this.placeholderPageType) {
        let oFilterPlaceHolder = {
          path: "data.pageType.iv",
          op: 'ne',
          value: this.placeholderPageType.id
        }
        finalFilter.push(oFilterPlaceHolder);
      }

      if (!lightRefresh) {
        const subscriptionCount =
          this.pageFacade.getFilteredPagination(countParm, ESchemaContentStatus.Published, finalFilter)
            .subscribe(p => {
              this.publishCount = p.length;

            });

        const subscriptionUnpublished =
          this.pageFacade.getFilteredPagination(draftParm, ESchemaContentStatus.Draft, finalFilter)
            .subscribe(unpublished => {
              unpublished.forEach(a => {
                this.pages.push(a);
                this.unpublishedPages.push(a);
                const data: any = { isCollapsed: true };
                this.collapseControlsEditTemplate[a.id] = data;
              });
            });
        this.subscriptions.push(subscriptionCount);
        this.subscriptions.push(subscriptionUnpublished);
      }

      const subscriptionPublished =
        this.pageFacade.getFilteredPagination(this.filter, ESchemaContentStatus.Published, finalFilter)
          .subscribe(published => {
            published.forEach(a => {
              this.pages.push(a);
              this.publishedPages.push(a);
              const data: any = { isCollapsed: true };
              this.collapseControlsEditTemplate[a.id] = data;
            });
          });

      this.subscriptions.push(subscriptionPublished);
    });
    this.subscriptions.push(subscription);

  }

  sortChange(sender: any): boolean {
    if (!sender) {
      this.selectedSort = 'Date de modification';
      this.selectedSortIndex = '0';
      this.search(null, true);
    } else {
      if (sender.target.text) {
        this.selectedSort = sender.target.innerHTML;
        this.selectedSortIndex = sender.target.attributes[3].value;
        this.search(null, true);
      }
    }
    return false;
  }

  sortChangeContents(sender: any): boolean {
    if (!sender) {
      this.selectedSort = 'Date de modification';
      this.selectedSortIndex = '0';


    } else {
      if (sender.target.text) {
        this.selectedSort = sender.target.innerHTML;
        this.selectedSortIndex = sender.target.attributes[3].value;
      }
    }

    if (this.selectedSortIndex === '1') {

      this.contentsAsPage = this.contentsAsPage.sort((one, two) =>
        (this.dataParser.pullData(one, 'metatitle', this.language) <= this.dataParser.pullData(two, 'metatitle', this.language) ? -1 : 1));
    } else if (this.selectedSortIndex === '2') {

      this.contentsAsPage = this.contentsAsPage.sort((one, two) =>
        (this.dataParser.pullData(one, 'metatitle', this.language) >= this.dataParser.pullData(two, 'metatitle', this.language) ? -1 : 1));
    } else {

      this.contentsAsPage = this.contentsAsPage.sort((one, two) => { return (new Date(two.lastModified).getTime() - new Date(one.lastModified).getTime()) });

    }
    return false;
  }

  getOrderBy() {
    if (this.selectedSortIndex === '1') {
      return `data.metatitle.${this.language} ascending`;
    } else if (this.selectedSortIndex === '2') {
      return `data.metatitle.${this.language} descending`;
    } else {
      return 'lastModified descending';
    }
  }

  getSearchObject(): object {
    const filter = this.searchControl.value == null ? EMPTY : this.searchControl.value;

    let oSearch = {
      or:
        [
          {
            path: `data.metatitle.${this.language}`,
            op: 'contains',
            value: filter
          },
          {
            path: `data.metaDescription.${this.language}`,
            op: 'contains',
            value: filter
          },
          {
            path: `data.code.iv`,
            op: 'contains',
            value: filter
          },
          {
            path: `data.pageName.iv`,
            op: 'contains',
            value: filter
          }
        ]
    }

    this.contentsAsPage = this.contentsAsPage.filter(p =>
      (this.dataParser.pullData(p, 'code', 'iv').toUpperCase().indexOf(filter.toUpperCase()) !== -1) ||
      (this.dataParser.pullData(p, 'pageName', 'iv').toUpperCase().indexOf(filter.toUpperCase()) !== -1) ||
      (this.dataParser.pullData(p, 'metaDescription', this.language).toUpperCase().indexOf(filter.toUpperCase()) !== -1) ||
      (this.dataParser.pullData(p, 'metatitle', this.language).toUpperCase().indexOf(filter.toUpperCase()) !== -1));

    return oSearch;
  }

  changeView() {
    this.listView = !this.listView;
    if (this.listView) {
      this.paginationSize = AppToken.PAGES_PUBLISHED_ITEMS_PER_PAGE + 1;
      this.paginationSizeChanged(this.paginationSize);
      this.paginationSizeContents = AppToken.PAGES_PUBLISHED_CONTENTS_ITEMS_PER_PAGE + 1;
      this.paginationSizeChangedContents(this.paginationSizeContents);
    } else {
      this.paginationSize = AppToken.PAGES_PUBLISHED_ITEMS_PER_PAGE;
      this.paginationSizeContents = AppToken.PAGES_PUBLISHED_CONTENTS_ITEMS_PER_PAGE;
    }
    this.initializeData();
    return false;
  }

  paginationSizeChanged(newSize: number) {
    if (this.listView) {
      this.paginationSize = newSize;
    } else {
      this.paginationSize = AppToken.PAGES_PUBLISHED_ITEMS_PER_PAGE;
    }
    this.filter.to = this.filter.from + this.paginationSize;
    this.initializeData();
  }

  paginationSizeChangedContents(newSize: number) {
    if (this.listView) {
      this.paginationSizeContents = newSize;
    } else {
      this.paginationSizeContents = AppToken.PAGES_PUBLISHED_CONTENTS_ITEMS_PER_PAGE;
    }
  }

  pageChanged($event) {
    this.currentPage = $event.page;
    this.search(null, true);
  }

  pageChangedContents($event) {
    this.currentPageContents = $event.page;
    this.search(null, true);
  }

  showPagination(publishCount: number, paginationSize: number) {
    if (publishCount) {
      if (publishCount > paginationSize) {
        return 'visible';
      }
    }
    return 'hidden';
  }

  updateListing() {
    this.filter.from = 0;
    this.filter.to = this.paginationSize;

    this.initializeData();
  }

  changeLanguage(event, languageCode) {
    this.dataParser.changeLanguage(languageCode);
    $(event.currentTarget).parent().parent().find('li').removeClass('active');
    $(event.currentTarget).parent().addClass('active');
  }
}

